import { useQuery, useMutation } from "@tanstack/react-query";
import { GET, POST, DELETE, PUT } from "../services/index";
import { message } from "antd";

export const UseFetchListEnum = () => {
  return useMutation(async (payload) => {
    try {
      const endPoint = `/api/v1/enums/list`;
      const { result } = await POST(endPoint, payload);
      return result;
    } catch (error) {
      await message.destroy();
      message.error("Failed To List Enum.. ");
    }
  });
};